import Button from 'components/Button';
import Information from 'components/Information';
import {FC} from 'react';
import {t} from 'ttag';
import {setUrl} from 'utils/request';

const clearUrlQuery = () => {
    const url = new URL(window.location.href);
    url.search = '';
    setUrl(url.toString());
};

type Props = {
    label: string;
};
const ClearFilteredResultsInformationDialog: FC<Props> = ({label}) => (
    <Information size="sm">
        <div className="inline-flex gap-2">
            {label}
            <Button kind="secondary" onClick={clearUrlQuery} size="xs">
                {t`Show all sending orders`}
            </Button>
        </div>
    </Information>
);
export default ClearFilteredResultsInformationDialog;
